module.exports = __webpack_public_path__ + "img/ico_new_model_white.d2c84960.svg";